export enum RiconoscimentoGenitoreItaliano {
  Madre = '1',
  Padre = '2',
  Entrambi = '3',
}
